import React from 'react';
import PropTypes from 'prop-types';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { ProviderProductPropType } from '../ProfilePropTypes';
import {
  BodyText,
  ExpandableText,
  Spacer,
  Stack,
} from '../../../ui';

export default function ProviderProductCard({
  product,
  highlight,
  renderActions,
}) {
  return (
    <Inline
      minHeight={70}
      borderWidth={1}
      borderStyle="solid"
      borderColor={BrandColor.LightGrey}
    >
      <Box width={16}>
        {highlight && <Box height="100%" width={8} color={BrandColor.Yellow} />}
      </Box>

      <Stack
        space={4}
        paddingY={16}
        maxWidth={220}
        justifyContent="center"
      >
        <BodyText emphasize testID="product-title">
          {product.title}
        </BodyText>
        <ExpandableText
          text={product.description}
          maxLength={80}
          maxWidth={220}
          textProps={{
            // needs to match service item font size so it has to override our bodytext
            appearance: 'medium',
            className: 'text',
            weight: 'thin',
            style: {
              fontSize: 13,
              lineHeight: 16,
            },
          }}
          testID="product-description"
        />
      </Stack>

      <Spacer />

      <Inline
        paddingY={20}
        paddingRight={16}
        alignItems="center"
        minWidth={80}
        maxHeight={120}
      >
        {renderActions()}
      </Inline>
    </Inline>
  );
}

ProviderProductCard.propTypes = {
  /** Provider Product to Display */
  product: ProviderProductPropType,
  /** If true then this product entry is given a highlight on the left side */
  highlight: PropTypes.bool,
  /* render the "actions" side of the product card */
  renderActions: PropTypes.func,
};

ProviderProductCard.defaultProps = {
  product: null,
  highlight: false,
  renderActions: () => null,
};
